// extracted by mini-css-extract-plugin
export default {"section":"ThirdComponent_section__qWI+3","form":"ThirdComponent_form__Z0L+X","control":"ThirdComponent_control__2XHq-","input":"ThirdComponent_input__FRYJU"};